import React from 'react';
import { connect } from 'react-redux';
import * as reducers from '../../store/reducers';
import * as uiActions from '../../store/ui/actions';
import { deactivateUser } from '../../store/users/actions';
import { getNameString } from '../../utilities';

import Button from 'Components/Button';
import ConfirmationDialog from 'Components/ConfirmationDialog';
import LoginAgainForm from 'Containers/LoginAgainForm';
import Lightbox from 'Components/Lightbox';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

class DeactivateUserButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmed: false,
    };

    this.handleClick = this.handleClick.bind(this);
    this.handleConfirmClick = this.handleConfirmClick.bind(this);
    this.cancelDeactivation = this.cancelDeactivation.bind(this);
    this.sendDeactivation = this.sendDeactivation.bind(this);
  }

  componentDidUpdate(prevProps) {
    const oldConfirmation = prevProps.confirmationDialog;
    const newConfirmation = this.props.confirmationDialog;

    if (
      oldConfirmation &&
      newConfirmation &&
      oldConfirmation.response !== newConfirmation.response &&
      newConfirmation.response === true
    ) {
      this.handleConfirmClick(this.props.isSensitiveTokenExpired);
    }

    if (
      prevProps.isSensitiveTokenExpired !==
        this.props.isSensitiveTokenExpired &&
      this.props.isSensitiveTokenExpired === false &&
      this.state.confirmed === true
    ) {
      this.setState({ confirmed: false });
      this.sendDeactivation();
    }
  }

  handleConfirmClick(expired) {
    this.props.clearConfirmationDialog();
    if (expired) {
      this.setState({ confirmed: true });
    } else {
      this.sendDeactivation();
    }
  }

  sendDeactivation() {
    this.props.deactivateUser(this.props.user.id);
  }

  cancelDeactivation() {
    this.setState({ confirmed: false });
  }

  handleClick(e) {
    const { user } = this.props;
    this.props.showConfirmationDialog('deactivateUser', {
      title: (
        <ConnectedFormattedMessage id="deactivate_user.confirmation_dialog.title" />
      ),
      question: (
        <ConnectedFormattedMessage
          id="deactivate_user.confirmation_dialog.question"
          values={{
            name: `“${getNameString(user)}”`,
          }}
        />
      ),
      trueLabel: (
        <ConnectedFormattedMessage id="deactivate_user.confirmation_dialog.true_label" />
      ),
      falseLabel: (
        <ConnectedFormattedMessage id="deactivate_user.confirmation_dialog.false_label" />
      ),
      clearOnFalse: true,
      data: {
        user,
      },
    });
  }

  render() {
    const components = [
      <Button
        label={<ConnectedFormattedMessage id="deactivate_user.button_label" />}
        buttonType="tertiary-cancel"
        additionalClasses=" Button--deactivate"
        clickHandler={e => this.handleClick(e)}
        key="A"
      />,
    ];

    if (this.props.confirmationDialog)
      components.push(
        <ConfirmationDialog key="B" {...this.props.confirmationDialog} />
      );
    components.push(
      <Lightbox
        type="small"
        visible={this.state.confirmed}
        closeHandler={e => this.cancelDeactivation()}
        header={
          <ConnectedFormattedMessage id="deactivate_user.password_dialog.header" />
        }
        key="C"
      >
        <p>
          <ConnectedFormattedMessage id="deactivate_user.password_dialog.body" />
        </p>
        <LoginAgainForm />
      </Lightbox>
    );
    return components;
  }
}

const mapStateToProps = state => {
  return {
    isSensitiveTokenExpired: reducers.isSensitiveTokenExpired(state),
    isDialogActive: reducers.isConfirmationDialogActive(
      state,
      'deactivateUser'
    ),
    confirmationDialog: reducers.getConfirmationDialog(state, 'deactivateUser'),
  };
};

export default connect(mapStateToProps, { ...uiActions, deactivateUser })(
  DeactivateUserButton
);
